import { Text } from 'common';

import { BlockSwitchField } from '../../../../../ConfigFields/Switch';
import { type HumanTaskBlockFormFieldsProps } from '../types';

export function HumanTaskIsRequiredBlockFormField(props: HumanTaskBlockFormFieldsProps) {
  const { fieldNamePrefix } = props;
  return (
    <BlockSwitchField
      label={<Text variant="body2">Required</Text>}
      fieldName={`${fieldNamePrefix}.isRequiredConditions`}
      toggleStates={{
        activeState: undefined,
        inactiveState: [],
      }}
    />
  );
}
